module.exports = fox._r("fonts/PTSans-Bold.svg", __webpack_public_path__ + "_/_/_/root/fonts/PTSans-Bold.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/PTSans-Bold.svg
// module id = 219
// module chunks = 4